module.exports = __webpack_public_path__ + "img/VALOR_TRANSPARENCIA2.05294bbb.png";